import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Title from "../components/Title";
import { CONTACT_PATH } from "../Routes/paths";
import { useNavigate } from "react-router-dom";
import Contact from "../components/Contact";

interface FleetManagementSystemProps {}

const FleetManagementSystem = ({}: FleetManagementSystemProps) => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      <Header />

      <main
        className={`w-full ${
          i18n.language === "en" ? "font-Poppins" : "font-Almarai"
        }`}
      >
        {/* hero section  *****************************/}
        <Title
          title={t("Fleet Management System")}
          subtitle={t("Services")}
          thirdTitle={t("Fleet Management System")}
        />

        {/* next section  ******************************/}
        <section className="my-[20px] px-[20px] w-full flex flex-col items-center justify-center gap-8 lg:gap-0 lg:flex-row lg:items-center lg:justify-around ">
          <div>
            <img src="../images/Fleet.png" alt="" />
          </div>
          <div>
            <p
              className={`max-w-[800px] lg:text-[14px] text-center ${
                i18n.language === "en" ? "lg:text-left" : "lg:text-right"
              }`}
            >
              {t(
                "Optimize your fleet operations with our comprehensive Fleet Management System. Designed to cater to businesses of all sizes, our system provides powerful tools to manage your vehicles efficiently, reduce operational costs, and enhance productivity. Our intuitive platform simplifies the complexities of fleet management, allowing you to focus on your core business operations.With our system, you can monitor your entire fleet in real-time, ensuring you have up-to-date information on vehicle locations, usage patterns, and driver performance. The advanced GPS tracking capabilities allow you to keep track of your vehicles, optimize routes, and respond quickly to any unexpected issues."
              )}
            </p>
          </div>
        </section>

        {/*  Our core service is developing **************/}
        <section className="my-[100px] px-[20px] lg:px-[144px] 2xl:px-[180px] w-full flex flex-col gap-10">
          <p className="font-[700] text-[24px] lg:text-[28px] flex items-center justify-center">
            {t("Why Choose Our Fleet Management System?")}
          </p>

          {/* grid section  *****************/}
          <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div>
              <p className="w-full font-[700] text-[20px]">
                {t("Vehicle Tracking")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Monitor your entire fleet in real-time with GPS tracking. Gain insights into vehicle locations, routes, and usage patterns."
                )}
              </p>
            </div>

            <div>
              <p className="w-full font-[700] text-[20px]">
                {t("Maintenance Management")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Schedule and track maintenance activities. Receive automated alerts for upcoming services and maintenance needs."
                )}
              </p>
            </div>

            <div>
              <p className="w-full font-[700] text-[20px]">
                {t("Fuel Management")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Track fuel consumption and expenses to identify inefficiencies and implement cost-saving measures."
                )}
              </p>
            </div>

            <div>
              <p className="w-full font-[700] text-[20px]">
                {t("Driver Management")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Maintain detailed records of driver information, performance, and behavior. Implement driver training and safety programs to improve performance."
                )}
              </p>
            </div>

            <div>
              <p className="w-full font-[700] text-[20px]">
                {t("Route Optimization")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Plan and optimize routes to reduce travel time, fuel consumption, and operational costs."
                )}
              </p>
            </div>

            <div>
              <p className="w-full font-[700] text-[20px]">
                {t("Reporting and Analytics")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Access detailed reports and analytics on fleet performance, helping you make data-driven decisions to improve efficiency and reduce costs."
                )}
              </p>
            </div>
          </div>
        </section>

        {/* Connect With Us: Your Voice Heard **************/}
        <Contact />
      </main>

      <Footer />
    </>
  );
};

export default FleetManagementSystem;
